module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M40.28 6.525L32 10.666v-8a2.664 2.664 0 0 0-2.667-2.667H2.666A2.664 2.664 0 0 0-.001 2.666v26.667A2.664 2.664 0 0 0 2.666 32h26.667A2.664 2.664 0 0 0 32 29.333v-8l8.28 4.141c1.32.659 2.387 0 2.387-1.475v-16c0-1.475-1.067-2.133-2.387-1.475z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/video-1.js
// module id = 1492
// module chunks = 14